module.exports = __webpack_public_path__ + "static/media/caic.6e4815a7.png";